/** @format */
import Guarantor from "../Assets/icons/Arabperson.svg";
import Guarantor2 from "../Assets/icons/Arabperson2.svg";
import {
  DashboardIcon,
  HistoryIcon,
  MangerIcon,
  StatsIcon,
  TechSupportIcon,
  OrdersIcon,
  DriversIcon,
  MoneyBagIcon,
  AirportsIcon,
  BannersIcon,
} from "../components/svg";
export const sideMenu = [
  {
    link: "/dashboard",
    activeIcon: <DashboardIcon fill=" #ff8900" />,
    icon: <DashboardIcon />,
    title: "لوحة التحكم",
  },
  {
    link: "/guarantor",
    activeIcon: (
      <img
        src={Guarantor2}
        alt="Guarantor"
        className={"active__icon right-menu__icon"}
      />
    ),
    icon: (
      <img src={Guarantor} alt="Guarantor" className={"right-menu__icon"} />
    ),
    title: "الكفيل",
  },
  {
    link: "/history",
    activeIcon: <HistoryIcon fill=" #ff8900" />,
    icon: <HistoryIcon />,
    title: "سجل الطلبات",
  },
  {
    link: "/service-domains",
    activeIcon: <OrdersIcon fill={" #ff8900"} />,
    icon: <OrdersIcon />,
    title: "اقسام الخدمات",
  },
  {
    link: "/drivers",
    activeIcon: <DriversIcon fill=" #ff8900" />,
    icon: <DriversIcon />,
    title: "السائقين",
  },
  {
    link: "/services-stats",
    activeIcon: <StatsIcon fill=" #ff8900" />,
    icon: <StatsIcon />,
    title: "احصائيات الخدمات",
  },
  {
    link: "/costs",
    activeIcon: <MoneyBagIcon fill=" #ff8900" />,
    icon: <MoneyBagIcon />,
    title: "المصروفات ",
  },
  {
    link: "/airports",
    activeIcon: <AirportsIcon fill=" #FF8900" />,
    icon: <AirportsIcon />,
    title: "المطارات ",
  },
  {
    link: "/banners",
    activeIcon: <BannersIcon fill=" #FF8900" />,
    icon: <BannersIcon />,
    title: "الاعلانات و العروض ",
  },
  {
    link: "/mangers",
    activeIcon: <MangerIcon fill=" #ff8900" />,
    icon: <MangerIcon />,
    title: "المشرفين ",
  },
  {
    link: "/support",
    activeIcon: <TechSupportIcon fill=" #ff8900" />,
    icon: <TechSupportIcon />,
    title: "الدعم الفني ",
  },
];

export const preparePaginationData = (data) => {
  let pagination = {
    current_page: data.current_page,
    hasNext: !!data.next_page_url,
    hasPrev: !!data.prev_page_url,
    totalPages: data.last_page,
  };
  return { pagination: pagination, data: data.data };
};
